import React from 'react';
import BuilderSelectMenu from '../../../components/Builder/BuilderSelectMenu';
import { CohortFilterType } from './types';

interface IProps {
  value: CohortFilterType;
  onChange: (newValue: CohortFilterType) => void;
}

const CohortDictionaryFilter = ({ value, onChange }: IProps) => {
  const options = [
    {
      value: CohortFilterType.AllCohorts,
      text: 'All Cohorts',
    },
    {
      value: CohortFilterType.YourCohorts,
      text: 'Created By You',
    },
  ];

  return (
    <BuilderSelectMenu
      label={'Filter By'}
      options={options}
      onChange={(newValue: string) => onChange(newValue as CohortFilterType)}
      value={value}
    />
  );
};

export default CohortDictionaryFilter;
